import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    color: 'bg-green-500',
    number: 1,
    title: 'Minis (6 a 12 años)',
    desc: 'Coordinación, juego y primeros contactos con la pelota'
  }, {
    color: 'bg-yellow-500',
    number: 2,
    title: 'Escuelita Principiantes (13 a 15 años)',
    desc: 'Técnica base y sistemas simples'
  }, {
    color: 'bg-orange',
    number: 3,
    title: 'Principiantes (16 a 17 años)',
    desc: 'Técnica consolidada y primeros sistemas tácticos'
  }, {
    color: 'bg-blue-500',
    number: 4,
    title: 'Principiantes Adultos (+17 años)',
    desc: 'Aprendizaje técnico adaptado al adulto'
  }, {
    color: 'bg-purple-500',
    number: 5,
    title: 'Recreativo con Experiencia (+17)',
    desc: 'Juego real, disfrute y técnica depurada'
  }, {
    color: 'bg-red-500',
    number: 6,
    title: 'Sub 11-12',
    desc: 'Formación motriz y voley adaptado'
  }, {
    color: 'bg-gray-800',
    number: 7,
    title: 'Sub 13-14',
    desc: 'Técnica individual y sistemas básicos'
  }, {
    color: 'bg-amber-700',
    number: 8,
    title: 'Sub 15-16',
    desc: 'Sistema 5-1, recepción y especialización'
  }, {
    color: 'bg-green-500',
    number: 9,
    title: 'Sub 18',
    desc: 'Alta competencia, K1-K2 y mentalidad'
  }, {
    color: 'bg-yellow-500',
    number: 10,
    title: 'Sub 21',
    desc: 'Rendimiento máximo y preparación profesional'
  }, {
    color: 'bg-orange',
    number: 11,
    title: 'Preparación Física Específica',
    desc: 'Fuerza, salto y prevención sin gimnasio'
  }, {
    color: 'bg-blue-500',
    number: 12,
    title: 'Drills por Categoría, Nivel y Posición',
    desc: '100+ ejercicios clasificados'
  }];
  const benefits = ['Ejercicios graficados en cada tomo', 'Sistema "Abrí y Entrenás"', 'Fichas listas para imprimir o usar en pantalla', 'Progresión técnica semana a semana', 'Sesiones con objetivo, desarrollo y cierre', 'Contenido 100% adaptado al contexto argentino'];
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-325">
      <div className="max-w-6xl mx-auto" data-id="element-326">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-327">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-328">
            Los 12 Tomos Completos
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-329">
            Ejercicios graficados · Por nivel y categoría · Listo para usar
            mañana
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-330">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-bg-card border border-border-card rounded-card p-6 hover:border-orange transition-colors" data-id="element-331">
              <div className="flex items-start gap-4" data-id="element-332">
                <div className={`w-3 h-3 rounded-full ${tomo.color} flex-shrink-0 mt-2`} data-id="element-333"></div>
                <div data-id="element-334">
                  <h3 className="text-lg font-bold mb-2" data-id="element-335">
                    Tomo {tomo.number} — {tomo.title}
                  </h3>
                  <p className="text-text-secondary" data-id="element-336">{tomo.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-337">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-3" data-id="element-338">
              <Check className="w-6 h-6 text-emerald-400 flex-shrink-0" data-id="element-339" />
              <span className="text-text-secondary" data-id="element-340">{benefit}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}